export default class CasesApi {
  constructor(client) {
    this.client = client;
  }

  async createCase(formData) {
    return this.client.request('/api/cases', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  }

  async getCases() {
    return this.client.request('/api/cases', { method: 'GET' });
  }

  async getCaseTypes() {
    return this.client.request('/api/cases/types', { method: 'GET' });
  }

  async getCaseById(caseId) {
    return this.client.request(`/api/cases/${caseId}`, { method: 'GET' });
  }

  async updateCase(caseId, caseData) {
    const formData = new FormData();

    if (caseData.title) formData.append('title', caseData.title);
    if (caseData.description) formData.append('description', caseData.description);
    if (caseData.urgency) formData.append('urgency', caseData.urgency);
    if (caseData.type) formData.append('type', caseData.type);
    if (caseData.status) formData.append('status', caseData.status);
    if (caseData.rejection_reason) formData.append('rejection_reason', caseData.rejection_reason);

    const documentsToUpload = caseData.documents || caseData.files;
    if (documentsToUpload && documentsToUpload.length > 0) {
      documentsToUpload.forEach((file) => formData.append('documents', file));
    }

    const url = `/api/cases/${caseId}`;
    const config = {
      method: 'PUT',
      headers: {},
      body: formData,
    };

    // Use client's underlying fetch wrapper to preserve auth header
    const response = await fetch(`${this.client.baseURL}${url}`, {
      method: config.method,
      headers: this.client.token ? { Authorization: `Bearer ${this.client.token}` } : {},
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Request failed');
    return data;
  }

  async cancelCase(caseId) {
    return this.client.request(`/api/cases/${caseId}/cancel`, {
      method: 'POST',
    });
  }
}
